<!--suppress ALL -->
<template>
  <div class="image-cropper">
    <g-modal :active.sync="modalActive" class="modal-cropper">
      <div class="box">
        <div class="image">
          <img :src="src" :id="id">
        </div>
        <div class="has-text-right">
          <g-button type="success" shape="sharped" @click="onCropImage()">
            {{$t('button.crop')}}
          </g-button>
        </div>
      </div>
    </g-modal>
    <div class="image">
      <template v-if="$scopedSlots.default || $slots.default">
        <slot></slot>
      </template>
      <lazy-img v-else :lazy-src="src"/>
      <div class="bg-overlay"></div>
      <div class="control">
        <slot name="button">
        </slot>
        <g-button type="info">
          <input type="file" accept="image/*" @change="onLoadImage($event)">
          <span>{{$t('button.add')}}</span>
        </g-button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  import {Component, Vue, Prop} from 'annotation';
  import {timeout} from '../../util/Delay';
  import {getBlobFile, resizeImage} from '../../util/UploadFileUtil';
  import {generateGUID} from '../../util/Underscore';
  import {isEmpty} from 'lodash';
  import Cropper from 'cropperjs';
  import 'cropperjs/dist/cropper.css';

  @Component
  export default class ImageUploader extends Vue {

    @Prop({default: 'Ganti foto', type: String})
    public title: string;

    @Prop({default: false, type: Boolean})
    public useTitleBold: boolean;

    @Prop({default: false, type: Boolean})
    public skipCropping: boolean;

    @Prop({type: String, default: 'cropp-image'})
    public id: string;

    @Prop({default: false, type: Boolean})
    public isHorizontal: boolean;

    @Prop({default: false, type: Boolean})
    public reduceImageSize: boolean;

    @Prop({default: false, type: Boolean})
    public isProfile: boolean;

    @Prop({default: 1, type: Number})
    public aspectRatio: number;

    @Prop({default: '', type: String})
    public fileLabelWidht: string;

    @Prop({default: '', type: String})
    public src: string;

    public modalActive: boolean = false;

    public imgWidth: number = 0;

    public imgHeight: number = 0;

    public cropper: any = null;

    public file: any = {name: ''};

    public get srcComputed() {
      return this.src;
    }

    public get hasTitle() {
      return !isEmpty(this.title);
    }

    public async onLoadImage(e: any) {
      this.file = e.target.files[0];

      if (!this.skipCropping) {
        this.modalActive = true;
        await timeout(500);

        try {
          this.onDestroyCropper();
          this.$emit('update:src', URL.createObjectURL(this.file));
        } catch (e) {
        }

        await this.onInitCropper();
      } else {
        this.$emit('update:src', URL.createObjectURL(this.file));
        this.handleResizeEmit();
      }
    }

    public handleResizeEmit() {
      if (this.reduceImageSize) {
        resizeImage(this.file).then((file: any) => {
          if (file instanceof File) {
            this.file = file;
          }

          this.emitFile();
        }).catch(() => {
          this.emitFile();
        });
      } else {
        this.emitFile();
      }
    }

    public emitFile() {
      this.$emit('crop-image', this.file);
      this.$emit('update:src', URL.createObjectURL(this.file));
    }

    public onDestroyCropper() {
      if (this.cropper) {
        this.cropper.destroy();
        this.cropper = null;
      }
    }

    public onCropImage() {
      if (!this.cropper) return;
      
      const src = this.cropper.getCroppedCanvas({
        width: this.imgWidth, height: this.imgHeight
      }).toDataURL('image/jpeg', 0.9);
      const file = new File([getBlobFile(src)], generateGUID() + '.jpg');

      this.file = file;
      this.handleResizeEmit();

      this.modalActive = false;
    }

    public async onInitCropper() {
      await timeout(500);

      let options: any = {
        crop: (e: any) => {
          this.imgWidth = e.width;
          this.imgHeight = e.height;
        }
      };

      if (this.aspectRatio) {
        options = Object.assign(options, {aspectRatio: this.aspectRatio});
      }

      const image = this.$el.querySelector('img#' + this.id) as HTMLImageElement;
      this.cropper = new Cropper(image, options);
    }
  }
</script>

<style lang="scss">
  @import "../../style/variables_function";

  .image-cropper {
    .modal {
      .has-text-right {
        margin-top: 1rem;
      }
    }
    > .image {
      position: relative;
      width: 100%;
      height: 100%;
      > .control {
        position: absolute;
        bottom: 15px;
        right: 15px;
        .button {
          &:only-child, &:last-child {
            width: 70px;
          }
          opacity: 0;
          font-size: 1rem;
          @include b-sh_def;
          transition: .5s;
          span {
            margin: 0;
          }
          input {
            opacity: 0;
            width: 100%;
            height: 100%;
            position: absolute;
          }
          & + .button {
            margin-left: .5rem;
          }
        }
      }
      .bg-overlay {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
      }
      &:hover {
        .bg-overlay {
          background-color: rgba(10, 10, 10, 0.5);
        }
        .button {
          opacity: 1.0;
        }
      }
    }
  }
</style>
